"use strict";
// IDUtils.js - Common DOM ID-related utilities.
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateRandomId = void 0;
/**
 * Generates a random string of a specific length to be used as a unique DOM ID.  The ID will always
 * be prefixed with `fds-`, followed by the randomly generated string.
 *
 * @param {Number} length The length of the ID string that will be generated. Default string size is 12.
 */
var generateRandomId = function (length) {
    if (length === void 0) { length = 12; }
    return "fds-" + Math.random().toString(36).substring(2, length + 2);
};
exports.generateRandomId = generateRandomId;
